import { MenuId } from './enum';
import {
    MENU_DOWNLOAD_SVG_ICON,
    MENU_ESTATE_SVG_ICON,
    MENU_FAQ_SVG_ICON,
    MENU_PAYMENT_SVG_ICON,
    MENU_REQUEST_SVG_ICON,
    MENU_VERIFY_SVG_ICON,
} from './logo';

export const menuPath: MenuPathType[] = [
    {
        id: MenuId.REQUEST_MANAGE,
        path: '/request/manage',
        subPath: [
            '/pds5',
            '/pds10',
            '/pds32',
            '/add',
            '/pds5-estate',
            '/applicant-building',
        ],
        icon: MENU_REQUEST_SVG_ICON,
    },
    {
        id: MenuId.VERIFY,
        path: '/verify',
        subPath: ['/tax', '/appraisal-price'],
        icon: MENU_VERIFY_SVG_ICON,
    },
    {
        id: MenuId.ESTATE,
        path: '/request/manage/estate',
        subPath: [],
        icon: MENU_ESTATE_SVG_ICON,
    },
    {
        id: MenuId.PAYMENT_HISTORY,
        path: '/payment-history',
        subPath: [],
        icon: MENU_PAYMENT_SVG_ICON,
    },
    {
        id: MenuId.FAQ,
        path: '/faq/list',
        subPath: [],
        icon: MENU_FAQ_SVG_ICON,
    },
    {
        id: MenuId.NEWS_MANAGE,
        path: '/news',
        subPath: ['/manage'],
        icon: '',
    },
    {
        id: MenuId.FAQ_MANAGE,
        path: '/faq',
        subPath: ['/manage'],
        icon: '',
    },
    {
        id: MenuId.DOCUMENT,
        path: '/document',
        subPath: ['/manage', '/form'],
        icon: MENU_DOWNLOAD_SVG_ICON,
    },
    {
        id: MenuId.MESSAGE,
        path: '/message',
        subPath: [],
        icon: '',
    },
    {
        id: MenuId.PROFILE,
        path: '/profile',
        subPath: ['manage', 'change-password'],
        icon: '',
    },
    {
        id: 'custom_id_manual',
        path: '/manual',
        subPath: [],
        icon: '',
    },
    {
        id: 'custom_id_download_mobile',
        path: '/download-mobile',
        subPath: [],
        icon: '',
    },
];
